<template>
  <div class="wrapper">
    <div class="terms-conditions">
      <div class="widget-body">
        <div class="info-panel">
          <button class="back-btn" @click="$router.push({ path: '/' })">
            <img src="../assets/icons/back__ic.svg" />
            <span>Go Home</span>
          </button>
          <terms-widget />
          <div class="bottom">
            <button class="__transparent" @click="$router.push({ path: '/' })">
              Go Home
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TermsWidget from "@/components/TermsWidget.vue";
export default {
  name: "signup",
  components: {
    TermsWidget,
  },
  computed: {},
  watch: {},
  data() {
    return {};
  },
  mounted() {
    let vm = this;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-size: contain;
  z-index: 999999;
  background: #fff;
}
.__container {
  .form {
    display: flex;
    flex-direction: column;
    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .banner {
      margin: 20px 0px;
      h5 {
        font-weight: 400;
        font-size: 18px;
        text-align: center;
        color: #676879;
      }
      h1 {
        font-weight: 600;
        font-size: 24px;
        text-align: center;
        color: #000000;
      }
    }
    .login_form {
      margin-top: 0px;
      text-align: left;
      display: flex;
      flex-direction: column;
      @media (min-width: 300px) and (max-width: 630px) {
        padding-left: 20px;
        padding-right: 20px;
      }
      .chech-box {
        margin: 15px 0 10px 0;
        display: flex;
        align-items: center;
        input {
          margin-top: 3px;
          margin-right: 10px;
        }
        label {
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.36;
          letter-spacing: 0px;
          text-align: center;
          color: #000000;
        }
        .colored {
          cursor: pointer;
          text-decoration: underline;
          margin-left: 10px;
          color: #1890a9;
        }
      }
      .get-started {
        width: 291px;
        height: 45px;
        background: transparent
          linear-gradient(109deg, #1ba5a4 0%, #2f90b6 100%) 0% 0% no-repeat
          padding-box;
        border-radius: 10px;
        color: #fff;
        margin-top: 30px;
      }
      .label {
        color: #000;
        font-weight: normal;
        font-size: 14px;
        margin-top: 15px;
        margin-bottom: 4px;
        margin-left: 20px;
      }
      .error_input {
        border: 1px solid crimson !important;
        color: crimson;
      }
      .error-msg {
        color: crimson;
        text-align: left;
      }
    }

    .bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 15px;

      .btn-signup {
        width: 100%;
        height: 45px;
        @media (min-width: 300px) and (max-width: 630px) {
          width: 300px;
        }
      }
      input[type="checkbox"] {
        background-color: #ffffff;
        position: relative;
        top: -1px;
        margin-right: 5px;
      }
      .sign-in-up-option {
        color: #1ba5a4;
        font-weight: 800;
        margin-top: 20px;
        margin-bottom: 5px;
      }
      .loader {
        margin-top: 10px;
        img {
          width: 30px;
        }
      }
      .social-media-list {
        list-style: none;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        margin-top: 20px;
        padding-left: 0px;
        @media (min-width: 300px) and (max-width: 630px) {
          display: grid;
          grid-template-columns: 48% 48%;
          grid-gap: 10px;
        }

        li {
          &.divider {
            margin-right: 10px;
          }
          a {
            display: flex;
            align-items: center;
            background: #fff;
            padding: 5px 10px;
            border-radius: 10px;
            border: 1px solid #ccc;
            img {
              width: 20px;
            }
            span {
              margin-top: 2px;
              margin-left: 3px;
              color: #000000;
            }
            &:hover {
              background: #ededed;
              color: #fff;
            }
          }
        }
      }
      .dont-have-account {
        color: #8f95a4;
        a {
          color: #0884af;
          text-decoration: none;
        }
      }
    }
  }
}
.terms-conditions {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .widget-body {
    height: 100%;
    background: #efefef 0% 0% no-repeat padding-box;
    display: flex;
    justify-content: center;
    overflow-y: auto;
    padding-top: 50px;
    padding-bottom: 20px;
    .info-panel {
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 1px solid rgb(226, 226, 226);
      border-radius: 5px;
      width: 800px;
      padding-top: 40px;
      padding-bottom: 20px;
      padding-left: 30px;
      padding-right: 30px;
      display: inline-table;
      position: relative;

      .back-btn {
        position: absolute;
        top: 14px;
        outline: none;
        border: none;
        left: 14px;
        text-decoration: none;
        color: #2991b8;

        span {
          margin-left: 7px;
        }
        img {
        }
      }
      img.grey_logo {
        margin: 20px 0;
        float: left;
        width: 70px;
        height: 65px;
      }
      img.terms_svg {
        width: 100%;
        display: block;
        margin-top: 20px;
      }
      .bottom {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        button {
          outline: none;
        }
        .__accept {
          font-size: 14px;
          width: 280px;
          height: 25px;
          border-radius: 18px;
          color: #fff;
          background-image: linear-gradient(267deg, #1885ad, #00a3a8);

          outline: none;
          cursor: pointer;
        }
        .__transparent {
          margin-top: 10px;
          color: #2991b8;
        }
      }
    }
  }
}
</style>


